import React from 'react'
import { Link } from 'react-router-dom';

export default function ReadyToWork() {
    return (
        <>
        <div className="ready-to-con">
              <div className='ready-to-title'>Ready to Work, Let's Chat</div>
              <div className='ready-to-description'>Our team of experts is ready to collaborate with</div>
              <div className='ready-to-description'>you every step of the way, from initial consultation to implementation.</div>
              <Link to='/contact-us'><div className='ready-to-button'>Contact Us Today!</div></Link>
        </div>
        </>
    )
};
